"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnsCreator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const constants_1 = require("@dzambalaorg/constants");
const mui_scanner_1 = require("@dzambalaorg/mui-scanner");
// prettier-ignore
const columnsCreator = (formatMessage) => [
    {
        field: "id",
        headerName: formatMessage({ id: "form.labels.id" }),
        sortable: true,
        flex: 0.3
    },
    {
        field: "account",
        headerName: formatMessage({ id: "form.labels.account" }),
        sortable: true,
        renderCell: (params) => {
            return ((0, jsx_runtime_1.jsx)(mui_scanner_1.AddressLink, { address: params.value }));
        },
        flex: 2,
        minWidth: 360
    },
    {
        field: "deposit",
        headerName: formatMessage({ id: "form.labels.deposit" }),
        sortable: true,
        flex: 1,
        minWidth: 100
    },
    {
        field: "ponziRule",
        headerName: formatMessage({ id: "form.labels.ponziRule" }),
        sortable: true,
        flex: 1,
        minWidth: 100
    },
    {
        field: "createdAt",
        headerName: formatMessage({ id: "form.labels.createdAt" }),
        sortable: true,
        valueFormatter: (value) => (0, date_fns_1.format)((0, date_fns_1.parseISO)(value), constants_1.humanReadableDateTimeFormat),
        flex: 1,
        minWidth: 160
    }
];
exports.columnsCreator = columnsCreator;
//# sourceMappingURL=schemas.js.map